import { Language } from '@/context/localeContext'

export const WHITE_CARD_SHORTNAME = 'white card'

export const WORKER_TYPES = {
  VISITOR: 'VISITOR',
  MANUALLY_CREATED_WORKER: 'MANUALLY_CREATED_WORKER',
}

export enum WorkerTabs {
  info = 'Information',
  inductions = 'induction:plural',
  tickets = 'ticket:plural',
  signOns = 'Sign Ons',
  permits = 'Permits',
  swms = 'swms:labels.signedSwms',
  documents = 'Documents',
  accessControl = 'Access Control',
}

export const TRADES: Record<Language, string[]> = {
  [Language.English]: [
    'Apprentice',
    'Asphalter',
    'Boilermaker',
    'Bricklayer',
    'Carpenter',
    'Cleaner',
    'Concreter',
    'Demolition',
    'Drainer',
    'Electrician',
    'Engineer',
    'Fire technician',
    'Glazier',
    'Ground staff',
    'Joiner',
    'Labourer',
    'Landscaper',
    'Level 1 testing',
    'NBN installation',
    'Painter',
    'Pavement crew',
    'Pit builder',
    'Plant operator',
    'Plasterer',
    'Plumber',
    'Project manager',
    'Rigger',
    'Roof plumber',
    'Roofer',
    'Scaffolder',
    'Security',
    'Sewer crew',
    'Signwriter',
    'Site supervisor',
    'Sprinkler fitter',
    'Steel fixer',
    'Surveyor',
    'Tiler',
    'Trade Assistant',
    'Traffic controller',
    'Water crew',
    'Waterproofer',
    'Welder',
    'Other',
  ],
  [Language.Spanish]: [
    'Aprendiz',
    'Asfaltador',
    'Calderero',
    'Albañil',
    'Carpintero',
    'Limpiador',
    'Hormigonero',
    'Demolición',
    'Fontanero',
    'Electricista',
    'Ingeniero',
    'Técnico de incendios',
    'Cristalero',
    'Personal de tierra',
    'Ebanista',
    'Obrero',
    'Paisajista',
    'Pruebas de nivel 1',
    'Instalación NBN',
    'Pintor',
    'Equipo de pavimentación',
    'Constructor de fosos',
    'Operador de planta',
    'Yesero',
    'Fontanero',
    'Gerente de proyecto',
    'Aparejador',
    'Plomero de techos',
    'Techador',
    'Andamiero',
    'Seguridad',
    'Equipo de alcantarillado',
    'Rotulista',
    'Supervisor de obra',
    'Instalador de rociadores',
    'Fijador de acero',
    'Topógrafo',
    'Solador',
    'Asistente de comercio',
    'Controlador de tráfico',
    'Equipo de agua',
    'Impermeabilizador',
    'Soldador',
    'Otro',
  ],
}

export const TRADE_EMOJIS = {
  Apprentice: '👨‍🎓',
  Asphalter: '',
  Bricklayer: '🧱',
  Carpenter: '🪚',
  Cleaner: '🧹',
  Concreter: '🏢',
  Drainer: '',
  Electrician: '⚡️',
  Engineer: '📃',
  Glazier: '🪟',
  'Fire technician': '🔥',
  'Ground staff': '',
  Landscaper: '🌳',
  'Level 1 testing': '',
  'NBN installation': '🌎',
  Painter: '🎨',
  'Pavement crew': '',
  'Pit Builder': '⛏️',
  'Plant operator': '',
  Plasterer: '',
  Plumber: '🚿',
  'Project manager': '📋',
  Security: '🔐',
  'Sewer crew': '',
  Signwriter: '🚧',
  'Site supervisor': '',
  'Sprinkler fitter': '💦',
  Tiler: '🛀',
  'Trade Assistant': '👷',
  'Traffic Controller': '🚦',
  'Water crew': '💧',
  Waterproofer: '☔️',
  Welder: '👨‍🏭',
  Other: '👷',
}

export const EMPLOYMENT_STATUSES: Record<Language, string[]> = {
  [Language.English]: [
    'Full Time',
    'Part Time',
    'Casual',
    'Contractor',
    'Self Employed',
    'Apprentice',
  ],
  [Language.Spanish]: [
    'Tiempo completo',
    'Tiempo parcial',
    'Casual',
    'Contratista',
    'Independiente',
    'Aprendiz',
  ],
}
